import React, { useEffect, useState } from 'react'
import {
  Container,
  Row,
  Col
} from 'reactstrap'
import RenderDataModal from '../RenderViewModal/RenderViewModal'
import './MediaDialog.css'
import useAsyncService from '../../../../hooks/useAsyncService'
import { getUploadFileVersion } from '../../../../services/endpoints/downloader'
import { LoadIndicator } from 'devextreme-react'
import ICSErrorCard from '../../../../components/ICSErrorCard/ICSErrorCard'

export interface MediaDialogProps {
  onClose: () => void
  uploadFileVersionId: number
  fileName: string
  type: 'mp3' | 'mp4'
}
const MediaDialog: React.FC<MediaDialogProps> = ({ onClose, uploadFileVersionId, fileName, type }) => {
  const {serviceValue, serviceError, serviceLoading} = useAsyncService({
    initialArgs: uploadFileVersionId,
    serviceCall: getUploadFileVersion
  })

  const mediaType = type === 'mp3' ? 'audio' : 'video'

  const getBody = () => {    
    if(serviceLoading) {
      return (
           <LoadIndicator />
      )
    } else if(serviceError) {
      return(
          <ICSErrorCard
            code={'error'}
            message={serviceError}
            fields={[]}
          />
      )
    } else if(!serviceValue) {
      return <>Empty</>
    } else {
      return (
        <MediaPlayer mediaData={serviceValue} mediaType={mediaType} />          
      )
    }
  }

  return (
    <RenderDataModal onClose={onClose} title={`HTML File for ${fileName}`}>
      <Container className="notes-container">
        <Row className="notes-row">
          <Col>
            {getBody()}
          </Col>
        </Row>
      </Container>
    </RenderDataModal>
  )
}

interface MediaPlayerProps {
  mediaData: Blob
  mediaType: 'audio' | 'video'
}

const MediaPlayer: React.FC<MediaPlayerProps> = ({ mediaData, mediaType }) => {
  const [mediaUrl, setMediaUrl] = useState<string | null>(null)

  useEffect(() => {
    if (mediaData) {
      const url = URL.createObjectURL(mediaData)
      setMediaUrl(url)

      return () => URL.revokeObjectURL(url)
    }
  }, [mediaData])

  if (!mediaUrl) {
    return <div>Loading media...</div>
  }

  return (
    <>
      {mediaType === 'audio' ? (
        <audio controls src={mediaUrl}>
          Your browser does not support the audio element.
        </audio>
      ) : mediaType === 'video' ? (
        <video controls src={mediaUrl} style={{ width: '100%', maxWidth: '600px' }}>
          Your browser does not support the video element.
        </video>
      ) : (
        <div>Unsupported media type</div>
      )}
    </>
  )
}

export default MediaDialog
